import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AgentPaneContextType {
  isOpen: boolean;
  toggle: () => void;
  open: () => void;
  close: () => void;
  currentPrompt: string | null;
  setCurrentPrompt: (prompt: string | null) => void;
}

const AgentPaneContext = createContext<AgentPaneContextType | undefined>(undefined);

interface AgentPaneProviderProps {
  children: ReactNode;
}

export const AgentPaneProvider: React.FC<AgentPaneProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentPrompt, setCurrentPrompt] = useState<string | null>(null);

  const toggle = () => setIsOpen(prev => !prev);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  const value: AgentPaneContextType = {
    isOpen,
    toggle,
    open,
    close,
    currentPrompt,
    setCurrentPrompt,
  };

  return (
    <AgentPaneContext.Provider value={value}>
      {children}
    </AgentPaneContext.Provider>
  );
};

export const useAgentPane = (): AgentPaneContextType => {
  const context = useContext(AgentPaneContext);
  if (context === undefined) {
    throw new Error('useAgentPane must be used within an AgentPaneProvider');
  }
  return context;
};
